import { useReducer } from "react";
import { TUploadStep, TUploadStepAction, UPLOADSTAGELIST } from "../types";
import { modalReducer } from "./modal.reducer";

type TUseUploadModal = () => {
    step: TUploadStep
    isLoading: boolean;
    uploadDispatch: React.Dispatch<TUploadStepAction>
}

export const useUploadModal: TUseUploadModal = () => {
    // Инициализируем reducer
    const [step, uploadDispatch]: [TUploadStep, React.Dispatch<TUploadStepAction>] =
        useReducer(modalReducer, UPLOADSTAGELIST.Intro);

    // Флаг для показа лоадера
    const isLoading =
        step === UPLOADSTAGELIST.Upload;

    // Возвращаем API для компонента
    return {
        step,
        isLoading,
        uploadDispatch,
    };
};